import { useCallback, useState } from 'react'
import { Dropdown } from 'antd'
import { Bell } from 'lucide-react'
import { DismissibleTooltip } from '../../common/DismissibleTooltip'
import { useNotifications } from '../../../context/notifications'
import { NotificationDropdown } from './NotificationDropdown'
import { BellBadge, BellTriggerButton } from './styles/NotificationStyles'

export function NotificationBell() {
  const { unreadCount } = useNotifications()
  const [open, setOpen] = useState(false)
  const close = useCallback(() => setOpen(false), [])

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      popupRender={() => <NotificationDropdown onClose={close} />}
      placement="bottomRight"
      trigger={['click']}
    >
      <DismissibleTooltip title="Notifications">
        <BellTriggerButton
          type="text"
          aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'}
          icon={
            <BellBadge count={unreadCount} size="small" overflowCount={99}>
              <Bell size={16} />
            </BellBadge>
          }
        />
      </DismissibleTooltip>
    </Dropdown>
  )
}
